// extracted by mini-css-extract-plugin
export default {"primary":"IconStyles_primary__qVOUN","secondary":"IconStyles_secondary__2JrQB"};